import { DocumentReferenceViewModel } from "../../model/DocumentReferenceViewModel";
import { api, transformApiResponse } from "./BaseApi";

const examCasesApi = api.enhanceEndpoints({ addTagTypes: ["ExamCases"] }).injectEndpoints({
  endpoints: (builder) => ({
    getExamCases: builder.query<DocumentReferenceViewModel[], void>({
      query: () => "/ExamCase",
      transformResponse: transformApiResponse,
      providesTags: [{ type: "ExamCases", id: "LIST" }],
    }),
  }),
});

export const { endpoints, useGetExamCasesQuery } = examCasesApi;
